// @flow
import styled from 'styled-components';

export const Wrapper = styled.footer`
  line-height: ${props => props.theme.footerHeight}px;
  margin-top: ${props => props.theme.footerMargin}px;
  text-align: center;
  color: white;
  background-color: ${props => props.theme.colors.black};
`;

export const ALink = styled.a`
  color: white;
  text-decoration: none;
  font-weight: bold;
  &:hover {
    text-decoration: underline;
    text-decoration-color: ${props => props.theme.colors.green};
  }
`;



// WEBPACK FOOTER //
// ./src/components/footer/footer.styles.js